import { CollectionViewer, DataSource } from '@angular/cdk/collections';
import { catchError, finalize, distinctUntilChanged } from 'rxjs/operators';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { DataTableParams } from 'angular-datatables-all-versions';

import { InvoiceService } from '../../../shared/services/invoice.service';
import { IPaginationInvoices, Invoice } from '../../../shared/models';
import { NgDataTableSortFormatterUtility } from '../../../shared/common/tools/ngdatatablesort-formatter.utility';


export class InvoiceListDataSource implements DataSource<Invoice> {

  private invoicesSubject = new BehaviorSubject<Invoice[]>([]);
  private paginationSubject = new BehaviorSubject<IPaginationInvoices>({} as IPaginationInvoices);
  private loadingSubject = new BehaviorSubject<boolean>(false);
  private ngDataTableSortFormatterUtility = new NgDataTableSortFormatterUtility();

  public pagination = this.paginationSubject.asObservable().pipe(distinctUntilChanged());
  public loading$ = this.loadingSubject.asObservable();

  constructor(private service: InvoiceService) { }

  connect(_collectionViewer: CollectionViewer): Observable<Invoice[]> {
    return this.invoicesSubject.asObservable();
  }

  disconnect(_collectionViewer: CollectionViewer): void {
    this.invoicesSubject.complete();
    this.loadingSubject.complete();
    this.paginationSubject.complete();
  }

  load(invoiceType: string, search = '', offset = 1, limit = 50, sort = null, month = '', year = '') {
    console.log('load datasource', { invoiceType, search, offset, limit, sort, month, year });
    this.loadingSubject.next(true);

    const params: any = { offset, limit, search };
    if (month) {
      params.month = month;
    }
    if (year) {
      params.year = year;
    }

    this.service.findInvoice(params as DataTableParams, invoiceType).pipe(
      catchError(() => of([])),
      finalize(() => this.loadingSubject.next(false))
    ).subscribe((data: IPaginationInvoices) => {
      if (data && data.data) {
        this.invoicesSubject.next(data.data);
      } else {
        this.invoicesSubject.next([]);
      }

      if (sort) {
        let list = data.data;

        list = list.sort((item1, item2) => {
          const sortAsc = sort['sortAsc'];
          let fieldToSort = sort['sortBy'];
          let firstVal;
          let secondVal;

          firstVal = this.ngDataTableSortFormatterUtility.resolveObjectValue(fieldToSort, item1);
          secondVal = this.ngDataTableSortFormatterUtility.resolveObjectValue(fieldToSort, item2);

          firstVal = firstVal ? typeof firstVal === 'string' ? firstVal.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "") : firstVal : '';
          secondVal = secondVal ? typeof secondVal === 'string' ? secondVal.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "") : secondVal : '';

          return sortAsc ?
            firstVal < secondVal ? -1 : firstVal > secondVal ? 1 : 0
            :
            firstVal < secondVal ? 1 : firstVal > secondVal ? -1 : 0;
        });

        data.data = list;
      }

      this.paginationSubject.next(data);
    });
  }

  compare(a, b, isAsc) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }
}
